import { motion } from 'framer-motion';
import { cn } from '../utils/cn';
import './ShimmerCtaButton.css';

/**
 * CTA with animated gradient border (Magic UI–style shimmer button pattern).
 */
export default function ShimmerCtaButton({
  children,
  className,
  buttonClassName,
  onClick,
  type = 'button',
  ...rest
}) {
  return (
    <div className={cn('shimmer-cta', className)}>
      <motion.button
        type={type}
        className={cn('shimmer-cta__inner', buttonClassName)}
        onClick={onClick}
        whileHover={{ scale: 1.03 }}
        whileTap={{ scale: 0.98 }}
        transition={{ type: 'spring', stiffness: 400, damping: 25 }}
        {...rest}
      >
        <span className="shimmer-cta__glow" aria-hidden />
        {children}
      </motion.button>
    </div>
  );
}
